import React from 'react'
import { Button } from 'react-bootstrap'
import { logOut } from 'state/async_actions'
import { useAppContext } from 'state/context'

export const ButtonText = 'Sign Out'
export const LogOutButton = () => {
  const [, dispatch] = useAppContext()

  const dispatchLogOut = () => logOut(dispatch)
  return (
    <Button id="logout" onClick={dispatchLogOut}>
      {ButtonText}
    </Button>
  )
}
